module.exports = __webpack_public_path__ + "img/84.58aa2b20.webp";